
export default {
  name: 'CompetitionTypes'
}
